module.exports = __webpack_public_path__ + "img/logo_1@2x.54d15498.png";